import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=86295fc6&scoped=true"
import script from "./FaqCategory.vue?vue&type=script&lang=js"
export * from "./FaqCategory.vue?vue&type=script&lang=js"
import style0 from "./FaqCategory.vue?vue&type=style&index=0&id=86295fc6&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86295fc6",
  null
  
)

export default component.exports